import { SUPPORT_MAILTO, SUPPORT_TELEGRAM } from './env';

export const footerOptions = [
    {
        id: '1',
        title: 'Контакты',
        items: [
            // {
            //     id: '1',
            //     label: 'Телеграмм',
            //     href: SUPPORT_TELEGRAM
            // },
            {
                id: '2',
                label: 'Отправить письмо',
                href: SUPPORT_MAILTO
            },
        ],
    },
    {
        id: '2',
        title: 'Информация',
        items: [
            {
                id: '1',
                label: 'Пользовательское соглашение',
                href: '/user-agreement'
            },
            {
                id: '2',
                label: 'Политика конфиденциальности',
                href: '/privacy-policy'
            },
            {
                id: '3',
                label: 'Правила пространства',
                href: '/community-guide'
            },
        ],
    },
]